import { useState, useEffect } from 'react'
import { Drawer, Typography } from '@evocolabs/orkaui'
import { Box } from '@mui/material'
import style from '@/pages/scss/OrkaTwo.module.scss'

import PlusCircle32 from '@evocolabs/icons/lib/PlusCircle32'
import PlusCircleFill32 from '@evocolabs/icons/lib/PlusCircleFill32'
import MinusCircle32 from '@evocolabs/icons/lib/MinusCircle32'
import MinusCircleFill32 from '@evocolabs/icons/lib/MinusCircleFill32'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import { disableBack, recoverDisableBack } from '@/src/utils/historyImprove'

import imgs from '../data/imgs'

import replaceBlueTooth from '@/src/utils/replaceBlueToothHelper'

const { techSpecsImgs } = imgs
const data = {
  title: `Tech Specs`,
  info: [
    {
      title: 'User',
      content: 'Adults with mild to moderately-severe hearing loss.'
    },
    {
      title: 'Technology',
      listMarginTop: '16px',
      list: [
        {
          title: 'Hearing Aids',
          ulMarginTop: '12px',
          li: `Bandwidth: < 200-8000Hz
                Automatic Gain Control (AGC)
                Wide Dynamic Range Compression (WDRC)
                Adaptive Feedback Cancellation (AFC)
                AI Adaptive DeNoise
                Adaptive Beamforming
                Multipoint Pairing
                Seamless Music Streaming
                Binaural Calling
                Double Tap Control (Accept/End Phone Call)
                Wear Detection
                Full Automatic Environment Classifier
                Hearing Aids OTA Upgrade`.split('\n')
        },
        {
          title: 'Charging Case',
          ulMarginTop: '12px',
          li: `Charging Case Remote Control Hearing Aids
                Wireless Charging
                Charging Case OTA Upgrade`.split('\n')
        }
      ]
    },
    {
      title: 'Battery',
      listMarginTop: '16px',
      list: [
        {
          title: 'Hearing Aids',
          ulMarginTop: '8px',
          li: `Battery type: Rechargeable lithium-ion battery
                Charging time (0%-100%): 1 hour 30 minutes
                Standby time: runs up to 12 hours under default settings and 36 hours with Charging Case`.split(
            '\n'
          )
        },
        {
          title: 'Charging Case',
          ulMarginTop: '8px',
          li: `Battery type: Rechargeable lithium-ion battery
                Charging time (0%-100%) with cable: 1 hour 30 minutes
                Charging time (0%-100%) with wireless charging: 3 hours`.split(
            '\n'
          )
        }
      ]
    },
    {
      title: 'Compatibility',
      listMarginTop: '16px',
      list: [
        {
          li: `Compatible with iOS 14 and later, Android 8 and later
            Achieved with Bluetooth 4.2/5.0/5.1/5.2/5.3`.split('\n')
        }
      ]
    },
    {
      title: 'Dimensions&Weight',
      listMarginTop: '24px',
      list: [
        {
          title: 'Hearing aids',
          variant: 't1',
          img: techSpecsImgs[0],
          table: [
            { title: 'Height', content: '1.1 inches (28.9 mm)' },
            { title: 'Width', content: '0.54 inches (13.6 mm)' },
            { title: 'Depth', content: '0.3 inch (9.0 mm)' },
            { title: 'Weight', content: '0.1 ounces (3.4g)' }
          ]
        },
        {
          title: 'Charging case',
          variant: 't1',
          img: techSpecsImgs[1],
          table: [
            { title: 'Height', content: '1.2 inches (31.5 mm)' },
            { title: 'Width', content: '3.2 inches (82.0 mm)' },
            { title: 'Depth', content: '2.2 inch (56.0 mm)' },
            { title: 'Weight', content: '2.6 ounces (75g)' }
          ]
        }
      ]
    }
  ]
}

const RenderUL = ({ ulMarginTop, list = [] } = props) => {
  return (
    <ul
      style={{
        marginTop: ulMarginTop || '0',
        paddingLeft: '20px',
        marginBottom: 0
      }}
    >
      {list.map((value, index) => {
        return (
          <li key={index} className={style['tech-specs-li']}>
            <Typography
              variant="body2"
              dangerouslySetInnerHTML={{ __html: replaceBlueTooth(value) }}
            ></Typography>
          </li>
        )
      })}
    </ul>
  )
}
const RenderImg = ({ src = '', alt = '' } = props) => {
  if (!src) return null
  return (
    <Box className={style['tech-specs-img']}>
      <img src={src} alt={alt} />
    </Box>
  )
}
const RenderTable = ({ table = [] } = props) => {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <tbody>
        {table.map((value, index) => (
          <tr key={index}>
            <td className={style['tech-specs-td-0']}>
              <Typography variant="body2">{value.title}</Typography>
            </td>
            <td className={style['tech-specs-td-1']}>
              <Typography variant="body2">{value.content}</Typography>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
const RenderList = ({ listMarginTop, list = [] } = props) => {
  if (list.length === 0) return null
  return (
    <Box>
      {list.map((value, index) => {
        return (
          <Box
            key={index}
            sx={{ '& + &': { marginTop: listMarginTop || '24px' } }}
          >
            <Typography variant={value.variant || 'Body2'}>
              {value.title}
            </Typography>
            <RenderUL list={value.li} ulMarginTop={value.ulMarginTop} />
            <RenderImg src={value.img} />
            <RenderTable table={value.table} />
          </Box>
        )
      })}
    </Box>
  )
}

const Add = () => {
  const [hovered, setHovered] = useState(false)
  const handleMouseEnter = () => {
    setHovered(true)
  }
  const handleMouseLeave = () => {
    setHovered(false)
  }
  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {hovered ? (
        <PlusCircleFill32 sx={{ color: '#26201F', fontSize: '28px' }} />
      ) : (
        <PlusCircle32 sx={{ color: '#26201F', fontSize: '28px' }} />
      )}
    </Box>
  )
}
const Minus = () => {
  const [hovered, setHovered] = useState(false)
  const handleMouseEnter = () => {
    setHovered(true)
  }
  const handleMouseLeave = () => {
    setHovered(false)
  }
  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {hovered ? (
        <MinusCircleFill32 sx={{ color: '#26201F', fontSize: '28px' }} />
      ) : (
        <MinusCircle32 sx={{ color: '#26201F', fontSize: '28px' }} />
      )}
    </Box>
  )
}

const TechSpecs = function ({ open, onClose } = props) {
  const [expanded, setExpanded] = useState(false)
  const clickHandler = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  const generateId = (i) => `panel${i}`
  useEffect(() => {
    if (open) {
      disableBack(() => {
        recoverDisableBack()
        onClose()
      })
    }
  }, [open])

  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        disableMobSizeAdjustment={true}
        sx={{
          top: { xs: '48px', dl: '0' },
          '>.MuiPaper-root': { top: { xs: '48px', dl: '0' } },
          ' .orkaui-drawer-container': {
            paddingBottom: '0',
            display: 'flex',
            height: '100%'
          }
        }}
      >
        <Box display="flex" flexDirection="column" height="100%">
          <Typography variant="h3">{data.title}</Typography>
          <Box mt="32px" className={style['tech-specs-img-box']}>
            {data.info.map((item, i) => (
              <Accordion
                id={`productbuy_tech_${item.title?.toLowerCase()}`}
                expanded={expanded === generateId(i)}
                key={i}
                style={{ width: '100%' }}
                className={style['product-faq-list-item']}
                onChange={clickHandler(generateId(i))}
              >
                <AccordionSummary
                  aria-controls={generateId(i) + 'bh-content'}
                  id={generateId(i) + 'bh-header'}
                  sx={{
                    padding: 0,
                    minHeight: 'unset !important',
                    lineHeight: 0,
                    margin: 0,
                    '&.Mui-expanded': { marginBottom: '16px !important' },
                    '>div': { margin: '0 !important' },
                    ' .MuiAccordionSummary-expandIconWrapper': {
                      transform: 'none'
                    }
                  }}
                  expandIcon={expanded === generateId(i) ? <Minus /> : <Add />}
                >
                  <Typography variant="T2" lineHeight="1.5">
                    {item.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  {item.content ? (
                    <Typography variant="body2">{item.content}</Typography>
                  ) : null}
                  <RenderList
                    list={item.list}
                    listMarginTop={item.listMarginTop}
                  />
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
      </Drawer>
    </>
  )
}

export default TechSpecs
